import React from 'react';

import { Screen, LogoSlot, IconBadge, Title, Message, StatPill, DismissButton } from './styled/LowCallVolumeReminderStyled';
import I2XLogo from '../common/icons/I2XLogo';
import useLocalization from '../../localization/useLocalization';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { dismissLowCallVolumeReminder } from '../../store/actions/lowCallVolumeReminder';
import type { RootState } from '../../store/types';

const PhoneIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={64} height={64} viewBox="0 0 48 48">
        <circle cx="24" cy="24" r="24" fill="#FFC400" />
        <path
            transform="translate(12 12)"
            fill="#4356DE"
            d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
        />
    </svg>
);

export function LowCallVolumeReminder() {
    const localization = useLocalization();
    const dispatch = useAppDispatch();
    const callCount = useAppSelector((state: RootState) => state.lowCallVolumeReminder.callCount);
    const periodHours = useAppSelector((state: RootState) => state.lowCallVolumeReminder.periodHours);

    return (
        <Screen data-testid="low-call-volume-reminder">
            <LogoSlot>
                <I2XLogo size={56} color="#fff" />
            </LogoSlot>

            <IconBadge>{PhoneIcon}</IconBadge>

            <Title>{localization.getText('trainer.lowCallVolumeReminder.title')}</Title>
            <Message>{localization.getText('trainer.lowCallVolumeReminder.subtext', { hours: periodHours })}</Message>
            <StatPill>
                {localization.getText('trainer.lowCallVolumeReminder.countLabel', { count: callCount, hours: periodHours })}
            </StatPill>

            <DismissButton data-testid="low-call-volume-reminder-dismiss" onClick={() => dispatch(dismissLowCallVolumeReminder('user'))}>
                {localization.getText('trainer.lowCallVolumeReminder.dismiss')}
            </DismissButton>
        </Screen>
    );
}

export default LowCallVolumeReminder;
